import { Component } from '@angular/core';

@Component({
  selector: 'app-mail-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './mail-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class MailIconComponent {}
